// src/utils/dateTimeUtils.js
// dateTimeUtils.js

/**
 * Formata uma data ou string de data/hora para o formato HH:mm
 * @param {Date | string} datetime - O objeto Date ou string.
 * @returns {string} - A hora formatada como HH:mm.
 */
export const formatTime = (datetime) => {
    if (typeof datetime === 'string') {
        const timeMatch = datetime.trim().match(/^(\d{1,2}):(\d{2})/);
        if (timeMatch) {
            return `${timeMatch[1].padStart(2, '0')}:${timeMatch[2]}`;
        }
    }

    const date = new Date(datetime);
    if (Number.isNaN(date.getTime())) {
        return '';
    }

    const hours = String(date.getHours()).padStart(2, '0'); // Garante dois dígitos
    const minutes = String(date.getMinutes()).padStart(2, '0'); // Garante dois dígitos
    return `${hours}:${minutes}`;
};

/**
 * Retorna o nome do dia da semana em português.
 * @param {number} dayIndex - Índice do dia, onde 0 representa domingo.
 * @returns {string} - Nome do dia da semana com a inicial maiúscula.
 */
export const getWeekdayName = (dayIndex) => {
    const weekdays = [
        'Domingo',
        'Segunda-feira',
        'Terça-feira',
        'Quarta-feira',
        'Quinta-feira',
        'Sexta-feira',
        'Sábado',
    ];

    return weekdays[Number(dayIndex)] || '';
};

/**
 * Formata uma data ou string de data/hora para o formato dd/mm/yyyy
 * @param {Date | string} datetime - O objeto Date ou string.
 * @returns {string} - A data formatada como dd/mm/yyyy.
 */
export const formatDate = (datetime) => {
    const date = new Date(datetime);
    const day = String(date.getDate()).padStart(2, '0'); // Garante dois dígitos
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};
